import React from 'react';
import { Toggle } from '@yme/molecules/toggle';
import { CONFIG } from '@yme/molecules/toggle/constants';
import { colorCoreBlack300, colorWhiteTransparent300 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel3, RegularTextLevel4 } from '@yme/tokens/typography';
import { FilterMenuItemStyled } from '../styled';
import { ToggleElementStyled } from './styled';
export function FilterToggle({ isActive, isRightToLeft, size = CONFIG.small, onClickHandler, placeholderOn, placeholderOff, label, isListItemView = false, }) {
    if (isListItemView) {
        return (React.createElement(FilterMenuItemStyled, null,
            React.createElement(FlexWrapper, { justifyContent: "space-between" },
                React.createElement(RegularTextLevel3, { as: "span" }, label),
                React.createElement(Toggle, { isActiveElement: isActive, isRightToLeft: isRightToLeft, size: size, onClickHandler: onClickHandler }))));
    }
    return (React.createElement(FlexWrapper, { flexDirection: "column", gap: "8px", bg: colorWhiteTransparent300 },
        React.createElement(RegularTextLevel4, { weight: 500 }, label),
        React.createElement(ToggleElementStyled, { justifyContent: "space-between", alignItems: "center" },
            React.createElement(RegularTextLevel4, { color: colorCoreBlack300 }, isActive ? placeholderOn : placeholderOff),
            React.createElement(Toggle, { isActiveElement: isActive, isRightToLeft: isRightToLeft, size: size, onClickHandler: onClickHandler }))));
}
